import React from 'react';
import { DistributorIcon } from '../../assets/icons';
import RoleCreatePage from '../RoleManagement/RoleCreatePage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './SubDistributorCreatePage.module.css';

const SubDistributorCreatePage: React.FC = () => (
  <RoleCreatePage config={ROLE_CONFIGS.subDistributor} styles={styles} Icon={DistributorIcon} />
);

export default SubDistributorCreatePage;
